import { render, staticRenderFns } from "./productBriefSourceList.vue?vue&type=template&id=01dfac96&scoped=true"
import script from "./productBriefSourceList.vue?vue&type=script&lang=js"
export * from "./productBriefSourceList.vue?vue&type=script&lang=js"
import style0 from "./productBriefSourceList.vue?vue&type=style&index=0&id=01dfac96&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dfac96",
  null
  
)

export default component.exports